const MemoryChip = ({ label, value, testId }) => (
  <div className="rounded-full border border-[#D4AF37]/25 bg-[#fff7e5] px-3 py-2" data-testid={testId}>
    <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#8b6d16]">{label}</p>
    <p className="mt-1 text-xs font-semibold text-[#001935]">{value}</p>
  </div>
);

export const AdvisorMemoryProfileCard = ({ profile }) => {
  if (!profile) return null;

  const chips = [
    profile.intent_label ? { label: "Mode", value: profile.intent_label, testId: "signature-advisor-memory-intent-chip" } : null,
    profile.budget_band ? { label: "Budget", value: profile.budget_band, testId: "signature-advisor-memory-budget-chip" } : null,
    profile.timeline ? { label: "Timeline", value: profile.timeline, testId: "signature-advisor-memory-timeline-chip" } : null,
    profile.preferred_districts?.length ? { label: "District", value: profile.preferred_districts[0], testId: "signature-advisor-memory-district-chip" } : null,
    profile.preferred_property_types?.length ? { label: "Property", value: profile.preferred_property_types[0], testId: "signature-advisor-memory-property-chip" } : null,
  ].filter(Boolean);

  if (!chips.length) return null;

  return (
    <div className="rounded-[22px] border border-[#D4AF37]/25 bg-white px-4 py-4 shadow-[0_10px_26px_rgba(0,25,53,0.06)]" data-testid="signature-advisor-memory-profile-card">
      <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#8b6d16]" data-testid="signature-advisor-memory-profile-eyebrow">Adaptive memory profile</p>
      <p className="mt-2 text-sm leading-7 text-[#5f5a4e]" data-testid="signature-advisor-memory-profile-note">{profile.confidence_note}</p>
      <div className="mt-4 flex flex-wrap gap-2" data-testid="signature-advisor-memory-profile-chip-group">
        {chips.map((chip) => <MemoryChip key={chip.testId} label={chip.label} testId={chip.testId} value={chip.value} />)}
      </div>
    </div>
  );
};